import { GetRoomsQuery, getSdk, Room } from '@/services/graphql';
import { graphqlClient } from '@/services/graphql-client';
import styles from '@/styles/Home.module.css';
import { useRouter } from 'next/router';
import { FC } from 'react';

import { Jumbotron } from '@/components/Jumbotron';
import { Layout } from '@/components/Layout';
import { GetStaticPaths, GetStaticProps } from 'next';

import { RoomDetailsCarousel } from '@/components/RoomDetailsCarousel';
import { useLocaleField } from '@/hooks/useLocaleField';
import { Container } from '@chakra-ui/react';
import { RoomDetailsInfo } from '@/components/RoomDetailsInfo';
import { RelatedRooms } from '@/components/RelatedRooms';

interface Props {
  room: Room;
  relatedRooms: GetRoomsQuery['allRoom'];
}

const RoomsPage: FC<Props> = ({ room, relatedRooms }) => {
  const { getLocaleField } = useLocaleField();

  return (
    <Layout pageTitle={getLocaleField(room.name) || ''}>
      <main className={styles.main}>
        <Jumbotron title={getLocaleField(room.name) || ''} />
        <Container maxW="8xl" mt="10">
          <RoomDetailsCarousel images={room.images} />
        </Container>
        <RoomDetailsInfo room={room} />
        <RelatedRooms relatedRooms={relatedRooms} />
      </main>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const sdk = getSdk(graphqlClient);

  const { data } = await sdk.getRoomBySlug({ slug: params?.slug as string });
  const { data: allRooms } = await sdk.getRooms();

  if (data.allRoom.length) {
    const room = data.allRoom[0];
    const relatedRooms = allRooms.allRoom.filter((item) => item._id !== room._id);

    return {
      props: {
        room,
        relatedRooms,
      },
    };
  }

  return {
    notFound: true,
  };
};

export const getStaticPaths: GetStaticPaths<{ slug: string }> = async () => {
  const sdk = getSdk(graphqlClient);

  const { data: allRoomsData } = await sdk.getRooms();

  return {
    paths: allRoomsData.allRoom.map((room) => ({
      params: { slug: room.slug?.current || 'not-found' },
    })),
    fallback: 'blocking',
  };
};

export default RoomsPage;
